import { render, staticRenderFns } from "./ReorderClass.vue?vue&type=template&id=ed885410&"
import script from "./ReorderClass.vue?vue&type=script&lang=js&"
export * from "./ReorderClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports